var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-autocomplete',{attrs:{"items":_vm.dimensions.items,"item-text":"name","item-value":"code","return-object":"","label":"Break-down Dimension","outlined":"","dense":""},on:{"change":_vm.selectDimension},model:{value:(_vm.dimension),callback:function ($$v) {_vm.dimension=$$v},expression:"dimension"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }